export default {
    namespaced: true,
    state: {
      livingAreas: [
        {
          id: 100,
          name: 'Eltern werden',
          icon: 'children',
          description: 'Sie werden demnächst Eltern oder haben bereits ein Kind bekommen? Glückwunsch, die Geburt eines Kindes ist eine aufregende Sache! Dennoch kommen jetzt einige Formalitäten auf Sie zu: Geburtsurkunde, Sorgerechtserklärung und vieles mehr. Damit Sie den Überblick behalten, finden Sie hier Dienstleistungen für diesen werdende Eltern.',
          services: [100, 101, 102],
          relatedArea: 101,
        },
        {
          id: 101,
          name: 'Ehe, Partnerschaft & Familie',
          icon: 'love',
          description: 'Sie werden demnächst Eltern oder haben bereits ein Baby bekommen? Mit der Geburt eines Kindes kommen auch einige Formalitäten auf Sie zu: Geburtsurkunde, Sorgerechtserklärung und vieles mehr. Damit Sie den Überblick behalten, finden Sie hier Informationen für werdende Eltern.',
          services: [100, 103, 105],
          relatedArea: 100,
        },
        {
          id: 102,
          name: 'Umzug nach/in Augsburg',
          icon: 'augsburg',
          description: 'Sie suchen eine neue Wohnung oder sind gerade umgezogen? Oder möchten Sie ein Haus bauen? Die eigenen oder gemieteten vier Wände sind wichtig für die Lebensqualität. In diesem Bereich finden Sie Dienstleistungen, Kontaktdaten und Antworten auf Fragen rund um die Themen Umzug und Wohnen.',
          services: [100, 103, 105],
          relatedArea: 101,
        },
        {
          id: 103,
          name: 'Schule, Ausbildung Studium',
          icon: 'education',
          description: 'Sie machen gerade Ihren Schulabschluss oder sind mitten in der Berufsausbildung? Bei Fragen rund um Themen wie Studium, Bildung und Ausbildung sind Sie hier richtig. Hier finden Sie passende Dienstleistungen, Anträge oder Nachweise.',
          services: [100, 103, 105],
          relatedArea: 102,
        },
        {
          id: 104,
          name: 'Selbstständigkeit & Gründen',
          icon: 'spacecraft',
          description: 'Sie haben den konkreten Wunsch sich selbstständig zu machen oder möchten ein Unternehmen gründen? Bei Fragen rund um die Slebstständigkeit sind Sie hier richtig. Hier finden Sie passende Dienstleistungen, Anträge oder Nachweise.',
          services: [100, 103, 105],
          relatedArea: 103,
        },
        {
          id: 105,
          name: 'Mobilität & Reisen',
          icon: 'car',
          description: 'Mobilität ist mehr als die Frage, wie man schnell, sicher und bequem von A nach B kommt. Mobilität ist eine entscheidende Grundlage für die alltägliche Lebenswirklichkeit vieler Menschen. Hier finden Sie Dienstleistungen zu Themen wie Fahrerlaubnis und Führerschein, die Zulassung Ihres Fahrzeugs und andere.',
          services: [100, 103, 105],
          relatedArea: 104,
        },
        {
          id: 106,
          name: 'Arbeit & Beruf',
          icon: 'work',
          description: 'Augen auf bei der Berufswahl! Der alte Spruch gilt noch immer. Damit Sie auch den passenden Beruf finden, erhalten Sie hier zahlreiche Beratungs- und Hilfsangebote. Außerdem finden Sie Antworten auf Fragen zu Themen wie Selbstständigkeit, Weiterbildung und vielem mehr.',
          services: [100, 103, 105],
          relatedArea: 105,
        },
        {
          id: 107,
          name: 'Steuern & Abgben',
          icon: 'taxes',
          description: 'Beim Wochenendeinkauf, Tanken oder der Lohnabrechnung: Wir alle zahlen Steuern und Abgaben. Jeder Steuer-Euro finanziert die Ausgaben des Staates, zum Beispiel für soziale Sicherung oder innere Sicherheit. Dieser Bereich bietet Ihnen einen Überblick über die wichtigsten Themen, Beratungsangebote und Leistungen zu Steuern, Abgaben und Gebühren – von der Hundesteuer bis zur Steuererklärung.',
          services: [100, 103, 105],
          relatedArea: 106,
        },
        {
          id: 108,
          name: 'Bauen & Wohnen',
          icon: 'build',
          description: 'Sie suchen eine neue Wohnung oder sind gerade umgezogen? Oder möchten Sie ein Haus bauen? Die eigenen oder gemieteten vier Wände sind wichtig für die Lebensqualität. In diesem Bereich finden Sie Informationen, Kontaktdaten und Antworten auf Fragen rund um die Themen Bauen und Wohnen.',
          services: [100, 103, 105],
          relatedArea: 107,
        },
        {
          id: 109,
          name: 'Gesundheit & Versichern',
          icon: 'healthcare',
          description: 'Hauptsache gesund! In diesem Bereich finden Sie vielfältige Informationen zur Gesundheitsvorsorge sowie zu den Leistungen der gesetzlichen Kranken- und Pflegeversicherung – von der Familienversicherung über Vorsorge und Früherkennung bis hin zu Impfungen. Außerdem haben wir zusammengestellt, wie der Staat den Sport unterstützt.',
          services: [100, 103, 105],
          relatedArea: 108,
        },
        {
          id: 110,
          name: 'Migration & Integration',
          icon: 'migration',
          description: 'Möchten Sie in Deutschland leben und arbeiten? Suchen Sie Informationen rund um Themen wie Asyl und Flüchtlingsschutz? Möchten Sie in Deutschland studieren? Hier sind Sie richtig. In diesem Bereich finden Menschen aus dem Ausland Beratungsangebote und Informationen.',
          services: [100, 103, 105],
          relatedArea: 109,
        },
      ]
    },
    mutations: {

    },
    actions: {

    },
    getters: {
      getAllLivingAreas: state => {
        return state.livingAreas;
      },
      getLivingAreaById: (state) => (id) => {
        return state.livingAreas.find(livingArea => livingArea.id == id)
      },
      getLivingAreasByTitle: state => (searchTerm) => {
        return state.livingAreas.filter(livingArea => livingArea.name.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/livingAreas.js